document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/pages/marshys') {
    const header = document.querySelector('header.header');
    if (header) {
      header.style.display = 'flex';
      header.style.justifyContent = 'space-between';
      header.style.padding = '10px 20px';
    }
  }
});